export function StringToHtml(input: string) {
  var lines = input.split('\n')
  return '<p>' + lines.join('</p><p>') + '</p>'
}

export function HtmlToString(input: Element) {
  var temp = document.createElement('div')
  filterHtml(temp, input.cloneNode(true) as Element)
  return temp.innerHTML
}

function filterHtml(output: Element, input: Element) {
  // Skip <br> tags completely
  if (input.tagName !== 'BR') {
    // We want the content of <p>s and <div>s, but not the elements themselves
    if (input.tagName === 'P' || input.tagName === 'DIV') {
      // Add new line in lieu of <p>/<div> if required.
      if (output.hasChildNodes()) {
        output.append('\n')
      }

      // Add children directly to the parent element
      appendFilteredChildren(output, input)
    }
    else {
      var shallowClone = input.cloneNode(false) as Element
      appendFilteredChildren(shallowClone, input)
      output.appendChild(shallowClone)
    }
  }
}

function appendFilteredChildren(output: Element, input: Element) {
  for (var i = 0; i < input.childNodes.length; i++) {
    var child = input.childNodes[i].cloneNode(true)
    if (child.nodeType === Node.ELEMENT_NODE) {
      filterHtml(output, child as Element)
    }
    else {
      output.appendChild(child)
    }
  }
}
